export class QaQcTestIdRequest {
    qaQcTestId: number;
    constructor(qaQcTestId: number){
        this.qaQcTestId = qaQcTestId
    }
}